/** In-app Part C MHA / PHA provider appointments portal. */
export const PART_C_PROVIDER_ROUTE = '/part-c-review';

/** Inner appointment detail so FormEngine can return to the same Part C page. */
export const PART_C_APPOINTMENT_QUERY = 'appointment';

/** Static testKey for dashboard card → Part C MHA / PHA Review. */
export const PART_C_REVIEW_TEST_KEY = 'mha_pha_review';
